// API Configuration with production support
const getApiBaseUrl = () => {
  // Production API URL from environment variable (highest priority)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Production custom domain - use API subdomain or same domain
  const hostname = window.location.hostname;
  if (hostname === 'med.aletheon.ai' || hostname.endsWith('.aletheon.ai')) {
    // If backend is on same domain, use relative path
    // Otherwise, use API subdomain (e.g., api.aletheon.ai)
    // For now, use environment variable - update REACT_APP_API_URL in Vercel
    return process.env.REACT_APP_API_URL || 'https://api.aletheon.ai';
  }
  
  // Development mode - localhost
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://127.0.0.1:5001';
  }
  
  // Local network testing (mobile devices)
  return `http://${hostname}:5001`;
};

const API_BASE_URL = getApiBaseUrl();

export default API_BASE_URL;